import React, { useState, useEffect, useRef, useMemo } from 'react';
import Filter from '@/pages/intelligence/pages/TopCharts/components/CommonFilter';
import TrendsCard from './components/TrendsCard';
import EditionsShareCard from './components/EditionsCard';
import CountriesCard from './components/CountriesCard';
import { useSelector, history } from 'umi';
import { getTopList, getMaketsType, getFixedTableData } from '../../utilsTmp/countryUtils';
import {
  statsRPDTrend,
  statsRPDEdition,
  statsRPDEditionLine,
  statsRPDCountryTable,
  statsRPDCountryTrend,
} from '@/pages/intelligence/services/topcharts';
import { sortTableByMetric } from '@/pages/intelligence/utils/tableUtils';
import useFilterExtend from '@/pages/intelligence/hooks/useFilterExtend';
import useEarliestTime from '../../utilsTmp/useEarliestTime';
import { DBI_TOPCHARTS } from '@/pages/intelligence/models/topcharts';
import ExportTable from '../../../../../../../components/ExportTable';
import { DownloadTitleTips } from '../_config';
import { getDefaultTime, getAppIdsListByPlatform } from '@/pages/intelligence/utils/topchartsUtils';
import { useMobileOptionList } from '@/pages/intelligence/pages/TopCharts/_hooks/useMobileOptionList';
import { getDbiFilterParams } from '@intelligence/utils/filterUtils';
import {
  updateShortLinkFilterId,
  updateTimeFilterValue,
  URL_FILTER_KEY,
  URL_APP_IDS,
  URL_CHART_METRIC,
  URL_SHORT_LINK_NAME,
  URL_COUNTRIES_TYPE,
} from '@intelligence/utils/urlPathCfg';
import { useMobileDetailShortLink } from '@intelligence/pages/TopCharts/MobileGames/components/GamesDetails/Stats/_hook';
import { toDateTypeFilter } from '@/pages/intelligence/utils/common';
import moment from 'moment';
import { mobileStats } from '@intelligence/v3/constants/downloadLogPoint';
import {
  buildCountriesChartDisplayList,
  buildCountriesTableDisplayList,
  buildCountriesChartRequestParams,
  getCountriesChartRequestMarketList,
} from '../_utils/countriesChartOthers';
import { getFirstWeekSinceReleaseDates, isFirstWeekSinceReleaseShortcut } from '../../utils';
import {
  renderOpinionEventToolbar,
  useMobileStatsOpinionEvents,
} from '../useMobileStatsOpinionEvents';

export default function RPDContext(props: any) {
  const {
    isBasicLoading,
    loading,
    setLoading,
    isCalibrated,
    tabType,
    pageId /** activeusers  revenue downloads*/,
    basicInfo,
    appIdListAll,
    // unPublishedAppIdList,
    gameId,
    appIds,
    regionsCountries,
    isTwoMonths,
    filterCfg,
    filterLoading,
    isCoutriesPage,
    shortLinkValidQuery,
    shortLinkFilterValue,
    urlCustomParams,
    entityType,
    combineGameIdList,
  } = props;
  const topchartsState = useSelector((state: any) => state?.[DBI_TOPCHARTS] || {});
  const DEFAULT_FORM_VALUE = filterCfg?.defaultValue || [];
  const { hasUrlShortLink } = filterCfg || {};

  const { rpdSegementOptions } = useMobileOptionList();
  const countryTypeRef = useRef('market');

  const [trendMetricSegVal, setTrendMetricSegVal] = useState(
    shortLinkValidQuery?.[URL_CHART_METRIC] || rpdSegementOptions[0].value,
  );
  // const [metricSegVal, setMetricSegVal] = useState(rpdSegementOptions[0].value);
  const [fetchParams, setFetchParams] = useState({
    app_ids: appIds,
    unified_id: gameId,
    entity_type: 'mobile',
    region_type: 'region',
    regions: ['global'],
    data_source: ['sensortower'],
    // data_source: ['appannie'],
    metrics: ['rpd', 'cumulative_revenue', 'cumulative_downloads'],
    date_type: 'monthly',
    start_date: '',
    end_date: '',
    check_metric: 'rpd',
    platforms: ['googleplay', 'appstore'],
  });

  const [trendLineList, setTrendLineList] = useState<any>([]);
  const [trendTableList, setTrendTableList] = useState<any>([]);
  const [editionLineList, setEditionLineList] = useState<any>([]);
  const [editionTotalList, setEditionTotalList] = useState<any>([]);
  const [editionTableList, setEditionTableList] = useState<any>([]);
  const [marketLineList, setMarketLineList] = useState<any>([]);
  // const [marketTotalList, setMarketTotalList] = useState<any>([]);
  const [marketTableList, setMarketTableList] = useState<any>([]);
  const [marketChartList, setMarketChartList] = useState<any>([]);
  const [trendLoading, setTrendLoading] = useState(loading);
  const [editionLoading, setEditionLoading] = useState(loading);
  const [marketLoading, setMarketLoading] = useState(loading);
  const [marketLineLoading, setMarketLineLoading] = useState(loading);
  const [topList, setTopList] = useState(
    /* <TopListProp>*/ {
      total: {},
      global: {},
      globalWoChina: {},
      list: [],
    },
  );
  const { isOperateDetail, detailFilterExtend, setDetailFilterExtend } = useFilterExtend({});
  // const marketChartTypeRef = useRef('bar');
  const [marketChartType, setMarketChartType] = useState<string>('bar');
  const [editionChartType, setEditionChartType] = useState<string>('bar');
  const [earliestCountry, setEarliestCountry] = useState('');
  const [trendError, setTrendError] = useState(false);
  const [editionError, setEditionError] = useState(false);
  const [marketError, setMarketError] = useState(false);
  // 因为cuntries的rpd，可视化切换指标时，表格和可视化数据都要重新排序，故放在此层控制
  const [countriesMetricSegVal, setCountriesMetricSegVal] = useState(rpdSegementOptions[0].value);
  const [editonFixedTableData, setEditionFixedTableData] = useState<any[]>([]);
  const [marketFixedTableData, setMarketFixedTableData] = useState([]);
  // 获取计算总数的类型字段
  const [marketType, setMarketType] = useState(
    getMaketsType(fetchParams.regions, fetchParams.regions),
  );
  const [filterValue, setFilterVale] = useState(
    isOperateDetail ? detailFilterExtend : DEFAULT_FORM_VALUE,
  );
  const [editionMetricSegVal, setEditionMetricSegVal] = useState(rpdSegementOptions[0].value);

  const {
    setEarliestDay,
    earliestPeriod,
    setEarliestPeriod,
    formattedEarliestDay,
    earliestLoading,
    getEarliestDayAndEarliesPeriod,
    updateEarliestDateData,
    baseReleaseTimeValue,
    baseReleaseTimeData,
  } = useEarliestTime({
    entityType: 'mobile',
    basicInfo,
    appIds,
    dateType: fetchParams.date_type,
    topchartsState,
  });

  const { enableOpinionEvents, controlledEventAnnotation, opinionEventToolbar } =
    useMobileStatsOpinionEvents({
      pageId,
      tabType,
      isCoutriesPage,
      gameId,
      combineGameIdList,
      entityType,
      fetchParams,
      trendLineList,
    });

  const {
    onTableSortChageTrend,
    onTableSortChageEdition,
    onTableSortChageCountrie,
    updateMobileDetailShortLink,
    updatePageCfgFromShortLink,
    trendPageSortAttr,
    editionPageSortAttr,
    countriesPageSortAttr,
    setEditionPageSortAttr,
    setCountriesPageSortAttr,
  } = useMobileDetailShortLink({
    coutriesType: countryTypeRef.current,
    trendSortMetric: 'date',
    editionSortMetric: editionMetricSegVal,
    countrieSortMetric: countriesMetricSegVal,
    shortLinkValidQuery,
    isCoutriesPage,
    marketChartType,
    editionChartType,
    setMarketChartType,
    setEditionChartType,
    trendSegement: trendMetricSegVal,
    setTrendSegement: setTrendMetricSegVal,
    editionSegement: editionMetricSegVal,
    setEditionSegement: setEditionMetricSegVal,
    coutriesSegement: countriesMetricSegVal,
    setCoutriesSegement: setCountriesMetricSegVal,
  });

  useEffect(() => {
    updatePageCfgFromShortLink();
    if (isCoutriesPage) {
      // if (shortLinkValidQuery?.[URL_CHART_TYPE] !== undefined) {
      //   marketChartTypeRef.current = shortLinkValidQuery?.[URL_CHART_TYPE];
      // }
      if (shortLinkValidQuery?.[URL_COUNTRIES_TYPE] !== undefined) {
        countryTypeRef.current = shortLinkValidQuery?.[URL_COUNTRIES_TYPE];
      }
    } else {
      // if (shortLinkValidQuery?.[URL_2_CHART_TYPE] !== undefined) {
      //   editionChartTypeRef.current = shortLinkValidQuery?.[URL_2_CHART_TYPE];
      // }
    }
  }, [shortLinkValidQuery]);

  useEffect(() => {
    if (!filterLoading && hasUrlShortLink) {
      updateMobileDetailShortLink();
    }
  }, [
    filterLoading,
    isCoutriesPage,
    editionChartType,
    marketChartType,
    countryTypeRef.current,
    trendMetricSegVal,
    editionMetricSegVal,
    countriesMetricSegVal,
  ]);

  const getPageData = (newFetchParams: any, updateFilterValues = filterValue) => {
    if (tabType === 'stats') {
      getStatsData(newFetchParams, updateFilterValues);
    } else if (isCoutriesPage) {
      getCountry(newFetchParams, countryTypeRef.current, updateFilterValues);
    } else {
      console.error(`tabType=${tabType} is not stats||countries!`);
    }
  };

  useEffect(() => {
    // 是否请求完basic接口
    if (isBasicLoading || filterLoading) {
      // 选择单appid时要重新loading
      setLoading(true);
    } else {
      let newFetchParams = { ...fetchParams };

      const hasUrlShortLinkVal = history.location.query?.[URL_SHORT_LINK_NAME];
      const { filterValue: newFilterValues, filterParams } = getDbiFilterParams({
        // urlFilter: any,
        urlCustomParams,
        urlShortLinkFilter: shortLinkFilterValue,
        filterSaveData: null,
        filterExtend: detailFilterExtend,
        specialParams: filterCfg?.specialParams,
        isOperate: isOperateDetail,
        filterName: '',
        filterKeyList: filterCfg?.filterKeyList ?? Object.keys(DEFAULT_FORM_VALUE),
      });

      // 如果有短链接，设置为继承模式
      if (isOperateDetail || hasUrlShortLinkVal) {
        // 如果目前是继承模式，就设置继承值为过滤后的筛选器值
        setDetailFilterExtend(newFilterValues);
      }
      setFilterVale(newFilterValues);
      newFetchParams = {
        ...newFetchParams,
        ...(urlCustomParams || {}),
        ...filterCfg?.handleFilterToApiParams(filterParams),
      };

      getPageData(newFetchParams, newFilterValues);
      /** 首次和切换国家筛选器时getEairly为true，调用最早时间函数 */
      updateEarliestDateData({
        dataSources: newFetchParams.data_source,
        metrics: newFetchParams.metrics,
        regionType: newFetchParams.region_type,
        regions: newFetchParams.regions,
        dateType: newFetchParams.date_type,
        platforms: newFetchParams?.platforms,
      });
    }
  }, [isBasicLoading, filterLoading, shortLinkFilterValue]);

  const getStatsData = async (params = fetchParams, updateFilterValues = filterValue) => {
    const newFetchParams = { ...fetchParams, ...params };
    newFetchParams.app_ids = getAppIdsListByPlatform(appIds, newFetchParams, appIdListAll);
    setFetchParams(newFetchParams);
    try {
      /** 接口速率优化：
       * 第一次时间为空时先请求trend获取时间后再请求channel；
       * 如果时间不为空，则可以同时请求2个接口
       */
      if (newFetchParams.start_date === '' || newFetchParams.end_date === '') {
        const { start_date, end_date } = await getTrends(newFetchParams);
        if (start_date && end_date) {
          newFetchParams.start_date = start_date;
          newFetchParams.end_date = end_date;
          getEdition(newFetchParams);
        } else {
          const [defautStart, defautEnd] = getDefaultTime(newFetchParams.date_type, isTwoMonths);
          newFetchParams.start_date = defautStart;
          newFetchParams.end_date = defautEnd;
          setEditionLoading(false);
        }
        setFetchParams(newFetchParams);

        const newFilterValue = updateTimeFilterValue({
          // hasUrlShortLinkVal,
          // haveFilterSaveBtn: false,
          // filterSaveName,
          filterValue: updateFilterValues,
          timeFilterValues: {
            type: newFetchParams.date_type,
            value: [newFetchParams.start_date, newFetchParams.end_date],
          },
        });
        setFilterVale(newFilterValue);
        if (hasUrlShortLink) {
          updateShortLinkFilterId({ [URL_FILTER_KEY]: newFilterValue, [URL_APP_IDS]: appIds });
        }
      } else {
        if (hasUrlShortLink) {
          updateShortLinkFilterId({ [URL_FILTER_KEY]: updateFilterValues, [URL_APP_IDS]: appIds });
        }
        getTrends(newFetchParams);
        getEdition(newFetchParams);
      }
    } catch (err) {
      console.error(err);
      setTrendLoading(false);
      setEditionLoading(false);
    }
  };

  const getTrends = async (params: any) => {
    setTrendLoading(true);
    setLoading(true);
    const newFetchParams = { ...fetchParams, ...params };
    setFetchParams(newFetchParams);
    try {
      const trendRes = await statsRPDTrend({ ...params });
      const startDate = trendRes?.req?.start_date;
      const endDate = trendRes?.req?.end_date;
      const reqApi = {
        ...newFetchParams,
        start_date: startDate,
        end_date: endDate,
      };
      setFetchParams({ ...reqApi });
      setTrendTableList(trendRes?.data?.data_list || []);
      setTrendLineList(trendRes?.data?.time_line || []);
      setTrendLoading(false);
      setLoading(false);
      setTrendError(false);
      return {
        start_date: startDate,
        end_date: endDate,
      };
    } catch {
      setTrendTableList([]);
      setTrendLineList([]);
      setLoading(false);
      setTrendLoading(false);
      setTrendError(true);
      return {
        start_date: '',
        end_date: '',
      };
    }
  };
  const getEdition = async (params: any) => {
    const newFetchParams = { ...fetchParams, ...params };
    setEditionLoading(true);
    try {
      const editionRes = await statsRPDEdition({
        ...newFetchParams,
        end_date:
          newFetchParams.date_type === 'monthly'
            ? `${moment(newFetchParams.end_date).format('YYYY-MM')}-01`
            : newFetchParams.end_date,
      });
      /** 将数据进行排序， 表格、柱状图排序展示， 可视化需要拿top5参数发给后端拿排序后的折线 */
      const dataList = editionRes?.data?.edition_data_list || [];
      const sortData = sortTableByMetric({
        tableData: dataList,
        sortParams: {
          ratioType: 0,
          sortVal: 'desc',
          sortMetric: editionMetricSegVal,
          // sortMetric: newFetchParams.check_metric,
        },
        timeProperty: 'date',
        metricProperty: 'name',
      });
      const totalList = editionRes?.data?.edition_data_total || [];
      setEditionFixedTableData(totalList);
      // 从basicinfo接口中提取头像和platform
      const tableList: any[] = [];
      sortData?.forEach((item: any) => {
        const appIdItem = appIdListAll.filter((obj: any) => obj?.id === item.app_id);
        tableList.push(Object.assign(item, ...appIdItem));
      });
      setEditionTableList(tableList || []);
      setEditionTotalList(editionRes?.data?.edition_data_total || []);
      setEditionError(false);

      if (editionChartType === 'line' || editionChartType === 'stackedLine') {
        const topAppids = getTopAppids(sortData);
        if (Array.isArray(topAppids) && topAppids?.length > 0) {
          getEditionTrends(newFetchParams, topAppids);
        }
      }
    } catch (err) {
      setEditionTableList([]);
      setEditionTotalList([]);
      setEditionLineList([]);
      setEditionError(true);
    }
    setEditionLoading(false);
  };

  const getEditionTrends = async (params = fetchParams, topAppid: string[] = []) => {
    const apiData = { ...params, app_ids: getAppIdsListByPlatform(topAppid, params, appIdListAll) };
    setEditionLoading(true);
    try {
      const res = await statsRPDEditionLine(apiData);
      const lineDataRes = res?.data?.metric_time_line || [];
      // 重组lineData , 将name 和 cover赋值给lineData
      const lineListMetric: any[] = [];
      lineDataRes?.forEach((metric: any) => {
        const newItem: any[] = [];
        metric?.edition_time_line?.forEach((item: any) => {
          const appIdItem = appIdListAll?.filter((obj: any) => obj?.id === item.app_id);
          if (appIdItem?.length > 0) {
            newItem.push(
              Object.assign(item, {
                name: appIdItem[0]?.name,
                cover: appIdItem[0]?.cover,
                platform: appIdItem[0]?.platform,
              }),
            );
          } else {
            newItem.push(item);
          }
        });
        lineListMetric.push({
          metric: metric?.metric,
          total_by_line: metric?.total_by_line,
          edition_time_line: newItem,
        });
      });
      setEditionLineList(lineListMetric || []);
      setEditionLoading(false);
    } catch (err) {
      setEditionLoading(false);
      setEditionLineList([]);
    }
  };

  const getCountry = async (params: any, countryType: string, updateFilterValues = filterValue) => {
    let newFetchParams = {
      ...fetchParams,
      ...params,
      region_type_share: countryType,
    };
    newFetchParams = {
      ...newFetchParams,
      region_type_share: countryType,
      start_date:
        toDateTypeFilter[newFetchParams.date_type] === 'month' && newFetchParams.start_date !== ''
          ? `${moment(newFetchParams.start_date).format('YYYY-MM')}-01`
          : newFetchParams.start_date,
      end_date:
        toDateTypeFilter[newFetchParams.date_type] === 'month' && newFetchParams.end_date !== ''
          ? `${moment(newFetchParams.end_date).format('YYYY-MM')}-01`
          : newFetchParams.end_date,
    };

    newFetchParams.app_ids = getAppIdsListByPlatform(appIds, newFetchParams, appIdListAll);
    setLoading(true);
    setMarketLoading(true);
    try {
      const isUpdateShortLinkNow = !!newFetchParams?.start_date && !!newFetchParams?.end_date;
      // 时间如果是空的，则需要更新时间筛选器
      const needUpdateTime = !newFetchParams?.start_date || !newFetchParams?.end_date;
      if (isUpdateShortLinkNow && hasUrlShortLink) {
        updateShortLinkFilterId({ [URL_FILTER_KEY]: updateFilterValues, [URL_APP_IDS]: appIds });
      }
      const resData = await statsRPDCountryTable(
        buildCountriesChartRequestParams(newFetchParams),
      );
      const startDate = resData?.req?.start_date;
      const endDate = resData?.req?.end_date;
      if (startDate && endDate) {
        newFetchParams.start_date = startDate;
        newFetchParams.end_date = endDate;
      } else {
        const [defautStart, defautEnd] = getDefaultTime(newFetchParams.date_type, isTwoMonths);
        newFetchParams.start_date = defautStart;
        newFetchParams.end_date = defautEnd;
      }
      setFetchParams(newFetchParams);

      const tableList = resData?.data?.country_data_list || [];
      const currentMetric = newFetchParams?.check_metric || countriesMetricSegVal;
      const sortData = sortTableByMetric({
        tableData: tableList,
        sortParams: {
          ratioType: 0,
          sortVal: 'desc',
          sortMetric: currentMetric,
          // sortMetric: newFetchParams.check_metric,
        },
        timeProperty: 'date',
        metricProperty: 'name',
      });
      const topListTmp = getTopList(sortData);
      const firstFixedData = getFixedTableData(marketType, topListTmp);

      setTopList(topListTmp);
      setMarketFixedTableData(firstFixedData);

      setMarketTableList(buildCountriesTableDisplayList(topListTmp.list));
      const chartDisplayList = buildCountriesChartDisplayList(topListTmp.list);
      setMarketChartList(chartDisplayList);

      // 获取到时间后更新筛选器的值，并更新url短链接
      if (needUpdateTime && startDate && endDate) {
        const newFilterValue = updateTimeFilterValue({
          // hasUrlShortLinkVal,
          // haveFilterSaveBtn: true,
          // filterSaveName,
          filterValue: updateFilterValues,
          timeFilterValues: {
            type: newFetchParams.date_type,
            value: [newFetchParams.start_date, newFetchParams.end_date],
          },
        });
        setFilterVale(newFilterValue);
        // 如果是时间为空等时间返回更新 且有短链接功能，则更新短链接
        if (!isUpdateShortLinkNow && hasUrlShortLink) {
          updateShortLinkFilterId({ [URL_FILTER_KEY]: newFilterValue, [URL_APP_IDS]: appIds });
        }
      }
      if (marketChartType === 'line' || marketChartType === 'stackedLine') {
        const topMarkets = getTopMarkets(topListTmp.list);
        getCountryTrends(newFetchParams, topMarkets);
      }
      setMarketError(false);
    } catch {
      setMarketLineList([]);
      setMarketTableList([]);
      setMarketChartList([]);
      setMarketError(true);
    }
    setMarketLoading(false);
    setLoading(false);
  };

  const getTopAppids = (tableList: any[]) => {
    /** 取排除total的Top5 */
    const tableExceptTotal = tableList.filter((t: any) => t.name !== 'Total');
    const appIds = [];
    tableExceptTotal.forEach((t: any) => {
      if (t?.app_id) {
        appIds.push(t?.app_id);
      }
    });
    return appIds.slice(0, 5);
  };

  const getTopMarkets = (chartList: any[]) => {
    return getCountriesChartRequestMarketList(chartList);
  };

  const changeEditionSegement = (value: string) => {
    setEditionPageSortAttr({
      currentSortValue: 'desc',
      currentSortMetric: value,
      currentRatioType: 0,
    });
    setEditionMetricSegVal(value);
    /** 将数据进行排序， 表格、柱状图排序展示， 可视化需要拿top5参数发给后端拿排序后的折线 */
    const sortData = sortTableByMetric({
      tableData: editionTableList,
      sortParams: {
        ratioType: 0,
        sortVal: 'desc',
        sortMetric: value,
      },
      timeProperty: 'date',
      metricProperty: 'name',
    });
    setEditionTableList(sortData);
    if (editionChartType === 'line' || editionChartType === 'stackedLine') {
      const topAppids = getTopAppids(sortData);
      getEditionTrends(fetchParams, topAppids);
    }
  };

  const changeMarketSegement = (value: string) => {
    countryTypeRef.current = value;
    // 修改参数
    getCountry(fetchParams, value);
  };

  const changeMarketSegementRight = (value: string) => {
    setCountriesPageSortAttr({
      currentSortValue: 'desc',
      currentSortMetric: value,
      currentRatioType: 0,
    });
    const newFetchParams = { ...fetchParams, check_metric: value };
    setFetchParams(newFetchParams);

    /** 将数据进行排序， 表格、柱状图排序展示， 可视化需要拿top5参数发给后端拿排序后的折线 */
    const sortData = sortTableByMetric({
      tableData: topList.list,
      sortParams: {
        ratioType: 0,
        sortVal: 'desc',
        sortMetric: value,
      },
      timeProperty: 'date',
      metricProperty: 'name',
    });
    setMarketTableList(buildCountriesTableDisplayList(sortData));
    const chartDisplayList = buildCountriesChartDisplayList(sortData);
    setMarketChartList(chartDisplayList);
    if (marketChartType === 'line' || marketChartType === 'stackedLine') {
      const topMarkets = getTopMarkets(sortData);
      getCountryTrends(newFetchParams, topMarkets);
    }
  };

  const getCountryTrends = async (params: any, topMarkets: string[]) => {
    const apiData = buildCountriesChartRequestParams(
      {
        ...params,
        country_trend_markets: topMarkets,
      },
    );
    setMarketLineLoading(true);
    try {
      // 首次请求后就把折线图数据存起来， 点折线图图片就直接取； 只有改变筛选器时才重新请求
      const res = await statsRPDCountryTrend(apiData);
      // setLineData(res?.data?.metric_country_time_line[0]?.Country_time_line)
      const lineDataTemp = res?.data?.metric_country_time_line || [];
      const lineDisplayData = lineDataTemp.map((item: any) => {
        return {
          ...item,
          Country_time_line: buildCountriesChartDisplayList(item?.Country_time_line),
        };
      });
      setMarketLineList(lineDisplayData);
    } catch (err) {
      setMarketLineList([]);
    }
    setMarketLineLoading(false);
  };
  // const changeTrendSegement = (value: string) => {
  //   /**切换segement时，更新聚合数据，更新可视化数据 */

  // };
  const changeEditionChartType = (value: string) => {
    setEditionChartType(value);
    if (value === 'line' || value === 'stackedLine') {
      const topAppids = getTopAppids(editionTableList);
      getEditionTrends(fetchParams, topAppids);
    }
  };

  const changeMarketChartType = (value: string) => {
    // marketChartTypeRef.current = value;
    setMarketChartType(value);
    if (value === 'line' || value === 'stackedLine') {
      const topMarkets = getTopMarkets(topList.list);
      getCountryTrends(fetchParams, topMarkets);
    }
  };

  const handleConfirm = (value: any, filter) => {
    const newFetchParams = { ...fetchParams, ...value };
    // 获取页面接口
    getPageData(newFetchParams, filter);
    // 如果不是操作时间筛选器则请求最早时间接口，否则不请求接口
    if (
      value?.region_type !== fetchParams?.region_type ||
      value?.regions !== fetchParams?.regions
    ) {
      updateEarliestDateData({
        dataSources: newFetchParams.data_source,
        metrics: newFetchParams.metrics,
        regionType: newFetchParams.region_type,
        regions: newFetchParams.regions,
        dateType: newFetchParams.date_type,
        platforms: newFetchParams?.platforms,
      });
    } else {
      /** 时间筛选器类型切换时， */
      const { earliestDay, earliestPeriod } = getEarliestDayAndEarliesPeriod(
        newFetchParams.date_type,
        newFetchParams.metrics,
      );
      setEarliestDay(earliestDay);
      setEarliestPeriod(earliestPeriod);
    }
  };

  const srouceValueCur = useMemo(() => {
    return Array.isArray(fetchParams?.data_source) && fetchParams?.data_source?.length > 0
      ? fetchParams?.data_source[0]
      : 'sensortower';
  }, [fetchParams]);

  const lineXAxisData = useMemo<string[] | undefined>(() => {
    if (!isFirstWeekSinceReleaseShortcut(topchartsState?.selectedTimeShortcutType)) {
      return undefined;
    }
    const firstWeekSinceReleaseDates = getFirstWeekSinceReleaseDates({
      dateType: fetchParams?.date_type,
      startDate: fetchParams?.start_date,
      endDate: fetchParams?.end_date,
      releaseDate: baseReleaseTimeValue,
    });
    return !!firstWeekSinceReleaseDates.length ? firstWeekSinceReleaseDates : undefined;
  }, [
    topchartsState?.selectedTimeShortcutType,
    fetchParams?.date_type,
    fetchParams?.start_date,
    fetchParams?.end_date,
    baseReleaseTimeValue,
  ]);

  return (
    <>
      <div className="dbi-statsfilter-warp">
        <div
          className={`statsfilter-warp-left${
            enableOpinionEvents ? ' dbi-mobile-stats-opinion-filter-wrap' : ''
          }`}
        >
          <Filter
            // timeFilterValues={{
            //   type: fetchParams.date_type,
            //   value: [fetchParams.start_date, fetchParams.end_date],
            // }}
            filterConfirm={handleConfirm}
            filterReset={() => {}}
            sinceReleaseTime={baseReleaseTimeValue}
            earliestDataTime={earliestPeriod}
            filterValue={filterValue}
            setFilterVale={setFilterVale}
            filterCfg={filterCfg}
            defaultValue={DEFAULT_FORM_VALUE}
          />
          {renderOpinionEventToolbar(opinionEventToolbar)}
        </div>
        <div className="dbi-statsfilter-warp-right">
          <ExportTable
            entityType="mobile"
            tableParams={{
              ...fetchParams,
              segment: pageId,
              unified_id: gameId,
              unified_ids: [gameId],
            }}
            downloadTitleTips={DownloadTitleTips}
            businessType="mobile-stats-countries-rpd"
            isDisableDownload={loading}
            isShowMaxDownloadRowsTips={false}
            downloadModalSize={820}
            isDisableDataAmount={true}
            isCalibrated={isCalibrated}
            newStyleFileName={`${basicInfo?.name}${
              tabType === 'stats' ? '_Stats' : isCoutriesPage ? '_Countries' : ''
            }`}
            isCoutriesPage={isCoutriesPage}
            downloadLogConfigKey={mobileStats?.[`${tabType}_${pageId}`]}
          />
        </div>
      </div>

      {isCoutriesPage ? (
        <CountriesCard
          loading={loading}
          marketChartList={marketChartList}
          tableData={marketTableList}
          lineData={marketLineList}
          changeSegement={changeMarketSegement}
          changeSegementRight={changeMarketSegementRight}
          metricSegVal={countriesMetricSegVal}
          setMetricSegVal={setCountriesMetricSegVal}
          regionsCountries={regionsCountries}
          chartType={marketChartType}
          setChartType={changeMarketChartType}
          // earlistDate={formattedEarliestDay}
          earliestCountry={earliestCountry}
          cardStatus={{
            isLoading: loading || marketLoading,
            isError: marketError,
            isNoData: !marketTableList?.length,
          }}
          fixedTableData={marketFixedTableData}
          asForDate={fetchParams?.end_date}
          dateType={fetchParams?.date_type}
          startDate={fetchParams?.start_date}
          endDate={fetchParams?.end_date}
          earliestLoading={earliestLoading}
          baseReleaseTime={baseReleaseTimeData}
          earliestPeriod={earliestPeriod}
          earliestDay={formattedEarliestDay}
          chartLineLoading={marketLineLoading}
          countriesType={countryTypeRef.current}
          pageSortAttr={countriesPageSortAttr}
          onTableSortChage={onTableSortChageCountrie}
          entityType={entityType}
          dataSource={srouceValueCur}
          lineXAxisData={lineXAxisData}
        />
      ) : (
        <>
          <TrendsCard
            lineData={trendLineList}
            tableData={trendTableList}
            earliestPeriod={earliestPeriod}
            earliestDay={formattedEarliestDay}
            // changeSegement={changeTrendSegement}
            cardStatus={{
              isLoading: loading || trendLoading,
              isError: trendError,
              isNoData: !trendTableList?.length,
            }}
            asForDate={fetchParams?.end_date}
            dateType={fetchParams?.date_type}
            earliestLoading={earliestLoading}
            baseReleaseTime={baseReleaseTimeData}
            onTableSortChage={onTableSortChageTrend}
            pageSortAttr={trendPageSortAttr}
            metricSegVal={trendMetricSegVal}
            setMetricSegVal={setTrendMetricSegVal}
            entityType={entityType}
            dataSource={srouceValueCur}
            lineXAxisData={lineXAxisData}
            trendLoading={trendLoading}
            enableOpinionEventAnnotation={enableOpinionEvents}
            controlledEventAnnotation={controlledEventAnnotation}
          />
          <EditionsShareCard
            lineData={editionLineList}
            tableData={editionTableList}
            totalList={editionTotalList}
            changeSegement={changeEditionSegement}
            chartType={editionChartType}
            setChartType={changeEditionChartType}
            cardStatus={{
              isLoading: loading || editionLoading,
              isError: editionError,
              isNoData: !editionTableList?.length,
            }}
            asForDate={fetchParams?.end_date}
            fixedTableData={editonFixedTableData}
            dateType={fetchParams?.date_type}
            pageSortAttr={editionPageSortAttr}
            onTableSortChage={onTableSortChageEdition}
            metricSegVal={editionMetricSegVal}
            entityType={entityType}
            dataSource={srouceValueCur}
            lineXAxisData={lineXAxisData}
          />
        </>
      )}
    </>
  );
}
